const appLocalization = {
  en: {
    home: 'Home',
    tvChannels: 'Tv channels',
    catalog: 'Catalog',
    search: 'Search',
    myMovies: 'My movies',
    settings: 'Settings',
    radio: 'Radio',
    more: 'More',
    collections: 'Collections',
    pressBackAgain: 'Press "Back" again to close app',
    holdToMenu: 'Press and hold "OK" to open context menu',
  },
  ru: {
    home: 'Главная',
    tvChannels: 'Телеканалы',
    catalog: 'Медиатека',
    search: 'Поиск',
    myMovies: 'Я смотрю',
    settings: 'Настройки',
    radio: 'Радио',
    more: 'Ещё',
    collections: 'Подборки',
    pressBackAgain: 'Нажмите "Назад" ещё раз, чтобы выйти',
    holdToMenu:
      'Чтобы открыть контекстное меню, нажмите и удерживайте кнопку ОК',
  },
};

export default appLocalization;
